document.addEventListener('DOMContentLoaded', function () {
    let tooltip = document.querySelectorAll('.has-tooltip')

    if (tooltip.length > 0) {
        document.querySelectorAll('.has-tooltip .open').forEach((openElem) => {
            openElem.addEventListener('click', function (event) {
                let closest = event.target.closest('.has-tooltip')

                if (closest.classList.contains('active')) {
                    closest.classList.remove('active')

                    let activeOverlay = closest.querySelector('.overlay.active')

                    if (activeOverlay) {
                        activeOverlay.classList.remove('active')
                    }

                    return
                }

                let activeTooltips = document.querySelectorAll('.has-tooltip.active')
                activeTooltips.forEach(function (element) {
                    element.classList.remove('active')
                })

                closest.classList.add('active')

                if (!event.target.classList.contains('no-overlay')) {
                    let overlay = closest.querySelector('.overlay')

                    if (overlay) {
                        overlay.classList.add('active')
                    }
                }
            })
        })

        document.querySelectorAll('.has-tooltip .close').forEach((closeElem) => {
            closeElem.addEventListener('click', function (event) {
                let closest = event.target.closest('.has-tooltip')
                closest.classList.remove('active')

                let activeOverlay = closest.querySelector('.overlay.active')

                if (activeOverlay) {
                    activeOverlay.classList.remove('active')
                }
            })
        })

        document.querySelectorAll('.has-tooltip .overlay').forEach((overlayElem) => {
            overlayElem.addEventListener('click', function (event) {
                let closest = event.target.closest('.has-tooltip')
                closest.classList.remove('active')

                let activeOverlay = closest.querySelector('.overlay.active')

                if (activeOverlay) {
                    activeOverlay.classList.remove('active')
                }
            })
        })

        document.addEventListener('mouseup', function (event) {
            let inside = Array.from(tooltip).some((el) => el.contains(event.target))

            if (!inside) {
                let activeTooltips = document.querySelectorAll('.has-tooltip.active')

                activeTooltips.forEach(function (element) {
                    element.classList.remove('active')

                    let activeOverlay = element.querySelector('.overlay.active')

                    if (activeOverlay) {
                        activeOverlay.classList.remove('active')
                    }
                })
            }
        })
    }
})
